import { useMemo } from 'react';
import { matchRoutes, useLocation } from 'react-router-dom';

import { IRoutePath } from '@selfserve/react-utils';

export const useCurrentRoute = (routes: IRoutePath[]): IRoutePath => {
  const location = useLocation();
  const match = matchRoutes(routes, location);
  const route = useMemo(() => {
    if (match) {
      const { route } = match[match.length - 1];
      return route;
    }
    return {};
  }, [match, routes]);

  return route as IRoutePath;
};
